import { render } from "./Field.vue?vue&type=template&id=0bb3a120&lang=pug"
import script from "./Field.vue?vue&type=script&lang=ts"
export * from "./Field.vue?vue&type=script&lang=ts"
script.render = render

export default script